import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

// 1. 建立 QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 預設 staleTime，可被個別 useQuery 覆蓋
      staleTime: 60 * 60 * 1000, // 1小時
    },
  },
});

// 2. 設定 localStorage 為快取持久化儲存
const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

// 3. 啟用快取持久化
persistQueryClient({
  queryClient,
  persister,
  maxAge: 6 * 60 * 60 * 1000, // 6小時內都會保留快取
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
